export default {
    popupBody: {
        padding: "0 40px 30px"
    },

    footer: {
        display: "flex",
        columnGap: "20px",
        justifyContent: "end",
        margin: "40px 0 0 0"
    },

    buttons: {
        width: "140px",
        height: "40px",
    },
}